// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upsell-after-cancel-modal__text[data-v-65cc932e]{font-size:14px}.upsell-after-cancel-modal__accent[data-v-65cc932e]{color:#fff;background-color:#556ee6;border-radius:8px;padding:12px 16px}.upsell-after-cancel-modal__list[data-v-65cc932e]{margin:0;padding-left:20px;font-size:14px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
